const RewardSummaryItems = ({
  summaryItems = [],
}) => (
  summaryItems.map(({
    id,
    icon,
    label,
    enabled,
  }) => (
    enabled ? (
      <div
        key={id}
        className="message"
      >
        <div className="icon-container">
          <img src={icon} alt={`${id} icon`} width={28} height={28} />
        </div>
        <p className="label-container">{label}</p>
      </div>
    ) : null
  ))
);

export default RewardSummaryItems;
